/*
 * @Description:
 * @Author: mdb
 * @Date: 2022-06-24 14:33:08
 * @LastEditTime: 2023-03-03 10:59:49
 * @LastEditors: mdb
 */
import request from '@/utils/request'
import { AxiosResult, IDParams, IDPaginationParams } from '@/typings/common'
import { BusinessParams, BusinessListResult, FbuBusinessEditParams } from '@/typings/api/chanceManage'

/**
 * ************************************** 商机 **************************************
 */
//  获取商机列表数据
export function businessList(data?: BusinessParams) {
  return request.post<BusinessListResult, BusinessListResult>('/ofbu/api/saleChance/page', data)
}
// 新增商机
export function businessCreateOrEdit(data: FbuBusinessEditParams) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/saleChance/createOrUpdate', data)
}
// 查询状态变更记录
export function businessStatusRecord(chanceId: string | number) {
  return request.get<AxiosResult, AxiosResult>(`/ofbu/api/saleChanceChangeRecord/${chanceId}`)
}
// 状态变更
export function businessChangeStatus(data: { id: string; status: number }) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/saleChance/changeStatus', data)
}
// 商机详情
export function businessDetails(data: IDParams) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/saleChance/get', data)
}
// 删除商机
export function businessDelete(data: IDParams) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/saleChance/delete', data)
}
// 分页查询客户名称-客户编码(线索和客户阶段数据)
export function getClueAndCustomerPage(data: IDPaginationParams) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer/name/getClueAndCustomerPage', data)
}
// 通过客户id查询关联商机列表(新增访客计划)
export function businessSelectListByRefId(saleChanceRefId: string) {
  return request.post<AxiosResult, AxiosResult>(`/ofbu/api/saleChance/selectListByRefId/${saleChanceRefId}`)
}
